import { useAppStore } from "@/global/store";
import { selectUser } from "@/global/store/data/user";
import {
  Box,
  Divider,
  Link,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from "@mui/material";
import { AiOutlineDollarCircle } from "react-icons/ai";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import { TbShirtSport } from "react-icons/tb";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import { createJsxLink } from "@/global/utils/utils.dom";

export const purchaseSeatsLanguages = {
  progressBarSuccessText: "Add more suites or checkout now!",
};

export const purchaseGiftCardLanguages = {
  pageTitle: "Give the gift of Diamondbacks Baseball",
  mainCardTitle: "Share a Gift",
  mainCardDescription:
    "Share the magic of Diamondbacks baseball with a friend or loved one. Upon purchase of the gift, a unique code will be generated for the intended recipient to redeem. Once redeemed, the gift is non-refundable.",
  amountTitle: "Gift Amount",
  recipientTitle: "Recipient",
  recipientEnabledDesc:
    "The Recipient will be sent an email with the unique code for them to redeem their gift. Once redeemed, the recipient will receive an account credit that they can use to purchase tickets for all Arizona Diamondbacks games at Chase Field.",
  recipientDisabledDesc:
    "If an intended recipient is not specified, once purchased, you will have to forward the unique code to the recipient. Upon your recipient receiving their gift, they will be prompted to enter their unique code to redeem the gift. Once redeemed, the recipient will receive an account credit that they use to purchase tickets for all Arizona Diamondbacks games at Chase Field.",
};

export const redeemGiftCardLanguages = {
  pageTitle: "Give the gift of Diamondbacks Baseball",
  mainCardTitle: "Redeem Gift",
  mainCardLoggedInDesc:
    "Please input the case sensitive code provided to redeem the value of the gift card to the Hippodrome Broadway Series in Baltimore account above.",
  mainCardLoggedOutDesc:
    "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster.",
  successDesc: "has been added to to your account!",
};

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "View Available Suites",
    description: "Shop for available suites at Chase Field.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      " Click Continue and connect your Arizona Diamondbacks account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Suites",
    description: "Select the suites you wish to purchase for each game.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description:
      "Tickets will be available in your Account Manager within 24 hours of redemption. Reach out to Live Fan Support for any questions.",
  },
];

export const faqs = [
  {
    title: "What is included with my D-backs Suite reservation?",
    description:
      "Each D-backs Suite includes your private suite, 18 game tickets, a complimentary menu of food and non-alcoholic beverage catered to your suite, gratuity for your in-Suite F&B attendant, and 3 parking passes in the Chase Field Garage.",
  },

  {
    title: "Are there other suites available, beyond what I’m seeing?",
    description: (
      <>
        Yes, currently only 18 guest D-backs Suites are available for purchase
        online. For additional information, or information about our other suite
        options click{" "}
        {createJsxLink(
          "here",
          "https://www.mlb.com/dbacks/tickets/premium/suites/information/request"
        )}
        , email{" "}
        {createJsxLink("suites@dbacks.com", `mailto:${"suites@dbacks.com"}`)},
        or call 602.462.4119.
      </>
    ),
  },
  {
    title: "I have more/less than 18 guests. Are there suite options for me?",
    description: (
      <>
        Yes, there are a variety of other suite options at Chase Field beyond
        those listed, ranging from 4 guests to over 200. For additional
        information, or information about our other suite options click{" "}
        {createJsxLink(
          "here",
          "https://www.mlb.com/dbacks/tickets/premium/suites/information/request"
        )}
        , email{" "}
        {createJsxLink("suites@dbacks.com", `mailto:${"suites@dbacks.com"}`)},
        or call 602.462.4119.
      </>
    ),
  },
  {
    title: "What happens after I purchase a D-backs Suite online?",
    description: (
      <>
        Following your purchase, a D-backs representative will follow up with
        you to confirm your order and assist with any questions you have in
        anticipation of your event. Tickets and parking will be added to your
        D-backs account where you’ll be able to access them via the MLB Ballpark
        app or in your D-backs account manager by visiting{" "}
        {createJsxLink(
          "www.dbacks.com/myaccount",
          "https://www.dbacks.com/myaccount"
        )}
        . All suite tickets are digital.
      </>
    ),
  },
  {
    title: "Are there additional taxes/fees?",
    description:
      "There are no additional taxes or fees on the pricing you see listed.",
  },

  {
    title: "Have questions about suites?",
    description: (
      <>
        For additional information, or information about our other suite options
        click{" "}
        {createJsxLink(
          "here",
          `https://www.mlb.com/dbacks/tickets/premium/suites/information/request`
        )}
        , email{" "}
        {createJsxLink("suites@dbacks.com", `mailto:${"suites@dbacks.com"}`)},
        or call 602.462.4119.
      </>
    ),
  },
];

export function TermsAndCondition() {
  return (
    <>
      By purchasing you agree to receive SMS alerts regarding ticket delivery
      and agree to the{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"

        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/616882d2b691e09f75348396_Terms%20%26%20Conditions.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms & Conditions
      </Link>{" "}
      and{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"
        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/63c05d80816dac05b5b34ac7_seasonshare%20CCPA%20Privacy%20Policy%20Agreement.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Privacy Policy
      </Link>
      .
    </>
  );
}
